import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmAlertModule, MmButtonModule, MmDialogModule, MmIconModule } from '@metromarkets/components';

import { ConfirmAccountCredentialsDialogComponent } from './confirm-account-credentials-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    MmDialogModule,
    MmButtonModule,
    MmIconModule,
    MmAlertModule,
  ],
  declarations: [ConfirmAccountCredentialsDialogComponent],
  exports: [ConfirmAccountCredentialsDialogComponent],
})
export class AppConfirmAccountCredentialsDialogModule {}
